import { render, staticRenderFns } from "./input-upload.vue?vue&type=template&id=ac4d1d2e&"
import script from "./input-upload.vue?vue&type=script&lang=js&"
export * from "./input-upload.vue?vue&type=script&lang=js&"
import style0 from "./input-upload.vue?vue&type=style&index=0&id=ac4d1d2e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports